import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchFeatureFlagSetting,
  fetchFeatureFlagSettings,
  updateFeatureFlagSetting
} from "../../actions/callrecorder/featureFlagSettingsActions";

export interface FeatureFlagSettingInterface {
  url: string;
  id: number;
  name: string;
  description: string | null;
  default_enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
  editId: null,
  editError: null
};

const adaptor = createEntityAdapter<FeatureFlagSettingInterface>();

const slice = createSlice({
  name: 'featureFlagSettings',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureFlagSettings.pending, (state, _action) => {
        state.status = 'loading';
      })
      .addCase(fetchFeatureFlagSettings.fulfilled, (state, action) => {
        state.count    = action.payload.count;
        state.entities = action.payload.featureFlagSettings;
        state.ids      = action.payload.ids;
        state.status   = 'succeeded';
      })
      .addCase(fetchFeatureFlagSettings.rejected, (state, action) => {
        state.status = 'failed';
        state.error  = action.error.message || 'Unknown Error';
      })

      .addCase(fetchFeatureFlagSetting.fulfilled, (state, action) => {
        const flag = action.payload?.featureFlagSetting && Object.values(action.payload.featureFlagSetting)[0];
        if (flag) {
          state.entities[flag.id] = flag;
        }
      })

      .addCase(updateFeatureFlagSetting.fulfilled, (state, action) => {
        const flag = action.payload?.featureFlagSetting && Object.values(action.payload.featureFlagSetting)[0];
        if (flag) {
          state.entities[flag.id] = flag;
        }
      })
      .addCase(updateFeatureFlagSetting.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const { setEditId, setEditError } = slice.actions;

export const {
  selectById: selectFeatureFlagSettingById,
  selectIds: selectFeatureFlagSettingIds,
  selectEntities: selectFeatureFlagSettingEntities,
  selectAll: selectAllFeatureFlagSettings,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.featureFlagSettings);
